export default "__VITE_ASSET__DwDP820j__"